import SmartLockTypeSelect from './SmartLockTypeSelect';

export default SmartLockTypeSelect;
